import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getManualExpenseTableContent(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/finance/providers/manual_expenses/`,
    oauthTokenHeader
  );
}

function getCurrencies(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/currencies/`, oauthTokenHeader);
}

function createExpense(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/finance/providers/manual_expenses/`,
    data,
    oauthTokenHeader
  );
}

function editExpense(
  oauthTokenHeader: string,
  data: any,
  expense_shared_uid: any
) {
  return fetchWrapper.put(
    `${apiUrl}/finance/providers/manual_expenses/${expense_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function deleteExpense(oauthTokenHeader: string, expense_shared_uid: any) {
  return fetchWrapper.delete(
    `${apiUrl}/finance/providers/manual_expenses/${expense_shared_uid}/`,
    oauthTokenHeader
  );
}

function postCommentME(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function fileUploadME(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/file/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function getFiles(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/file/${object_shared_uid}/`,
    oauthTokenHeader
  );
}

function getComments(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    oauthTokenHeader
  );
}

function putComments(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.put(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function deleteComment(oauthTokenHeader: string, object_shared_uid: any, comment_shared_uid: any) {
  return fetchWrapper.delete(`${apiUrl}/utilities/comments/${object_shared_uid}/?comment=${comment_shared_uid}`, oauthTokenHeader);
}

function deleteFile(oauthTokenHeader: string, file_shared_uid: any) {
  return fetchWrapper.delete(`${apiUrl}/utilities/file/${file_shared_uid}/`, oauthTokenHeader);
}

function getAllUsers(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/admin/users/?active_only=True/`, oauthTokenHeader);
};

function getTrafficSource(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/traffic_sources/`, oauthTokenHeader);
}

export const manualExpenseService = {
  getManualExpenseTableContent,
  getCurrencies,
  createExpense,
  editExpense,
  deleteExpense,
  postCommentME,
  fileUploadME,
  getFiles,
  getComments,
  putComments,
  deleteComment,
  deleteFile,
  getAllUsers,
  getTrafficSource
};
